import React, { useEffect, useState } from "react";
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Collapse } from "@material-ui/core";
import { ExpandLess, ExpandMore, Inventory, PlaylistAdd, DisplaySettings } from "@mui/icons-material";
import clsx from "clsx";
import { statusCount } from "./DrawerMenu.d";
import { useMenuStyles } from "./DrawerMenuStyles";
import MenuItem from "./DrawerMenuItem";
import consts from "../../utils/consts";
import useNavIndexFromLocation from "../../utils/navIndexUtil";
import { navIndex } from "../../utils/consts";
import { history } from "../../services/historyService";

const DrawerMenu: React.FC = () => {
	const classes = useMenuStyles();
	const navMenu = consts.leftNav;
	const defaultNavIndex = useNavIndexFromLocation();
	const [selectedMenuItem, setSelectedMenuItem] = useState(defaultNavIndex?.index ?? undefined);
	const [inventoryMenuOpen, setInventoryMenuOpen] = useState(false);

	const hideForTrial = true;

	const statusCountDefault: statusCount[] = [
	
	];

	useEffect(() => {
		setSelectedMenuItem(defaultNavIndex?.index ?? undefined);
		// Open the accordion if we're on one of the inventory update pages
		if (defaultNavIndex?.index === "InventoryUpdates" || defaultNavIndex?.index === "DisplayRequired") {
			setInventoryMenuOpen(true);
		}
	}, [defaultNavIndex]);

	const handleMenuItemSelected = (index: navIndex) => {
		setSelectedMenuItem(index);
		switch (index) {
			case "Home":
				history.push(consts.routerPath.home);
				break;
			case "Schedules":
				history.push(consts.routerPath.schedules);
				break;
			case "Criteria":
				history.push(consts.routerPath.criteria);
				break;
			case "Inventory":
				history.push(consts.routerPath.inventory);
				break;
			case "InventoryUpdates":
				history.push(consts.routerPath.inventoryUpdates);
				break;
			case "DisplayRequired":
				history.push(consts.routerPath.inventoryDisplayRequired);
				break;
			default:
				break;
		}
	};

	const handleAccordionClick = () => {
		// Don't allow closing the menu if either inventory update page is currently selected
		if (selectedMenuItem === "InventoryUpdates" || selectedMenuItem === "DisplayRequired") {
			return;
		}
		setInventoryMenuOpen(!inventoryMenuOpen);
	};

	return (
		<Drawer
			variant="permanent"
			className={clsx(classes.drawer, classes.drawerOpen)}
			classes={{
				paper: clsx(classes.drawer, classes.drawerOpen),
			}}
			anchor="left"
		>
			<div className={classes.drawerContainer}>
				<List component="nav" className={classes.list}>
					{navMenu.map((item) => {
						const statusCountItem = statusCountDefault.filter((x) => x.status === item.index)[0];
						const count = statusCountItem && statusCountItem.count > 0 ? statusCountItem.count : undefined;
						
						return (
							<MenuItem
								key={item.index}
								{...item}
								selected={selectedMenuItem === item.index}
								badgeContent={!hideForTrial && count}
								onClick={handleMenuItemSelected}
							/>
						);
					})}
					
					{/* Add the Inventory Updates accordion */}
					<ListItem
						button
						disableRipple
						className={classes.menuItem}
						onClick={handleAccordionClick}
					>
						<ListItemIcon>
								<Inventory titleAccess="Inventory Updates" className={classes.icon} />
						</ListItemIcon>
						<ListItemText primary="Inventory Updates" className={classes.text} />
						{inventoryMenuOpen ? <ExpandLess className={classes.icon} /> : <ExpandMore className={classes.icon} />}
					</ListItem>
					<Collapse in={inventoryMenuOpen} timeout="auto" unmountOnExit>
						<List component="div" disablePadding>
							<ListItem
								button
								disableRipple
								className={clsx(classes.menuItem, {
									[classes.selectedMenuItem]: selectedMenuItem === "InventoryUpdates",
								})}
								style={{ paddingLeft: 32 }}
								onClick={() => handleMenuItemSelected("InventoryUpdates")}
							>
								<ListItemIcon style={{ minWidth: 40 }}>
									<PlaylistAdd 
										titleAccess="Update Min/Max" 
										className={selectedMenuItem === "InventoryUpdates" ? classes.selectedIcon : classes.icon}
									/>
								</ListItemIcon>
								<ListItemText 
									primary="Update Min/Max" 
									className={selectedMenuItem === "InventoryUpdates" ? classes.selectedText : classes.text}
								/>
							</ListItem>
							<ListItem
								button
								disableRipple
								className={clsx(classes.menuItem, {
									[classes.selectedMenuItem]: selectedMenuItem === "DisplayRequired",
								})}
								style={{ paddingLeft: 32 }}
								onClick={() => handleMenuItemSelected("DisplayRequired")}
							>
								<ListItemIcon style={{ minWidth: 40 }}>
									<DisplaySettings 
										titleAccess="Update Display Required" 
										className={selectedMenuItem === "DisplayRequired" ? classes.selectedIcon : classes.icon}
									/>
								</ListItemIcon>
								<ListItemText 
									primary="Update Display Required" 
									className={selectedMenuItem === "DisplayRequired" ? classes.selectedText : classes.text}
								/>
							</ListItem>
						</List>
					</Collapse>
				</List>
			</div>
		</Drawer>
	);
};

export default DrawerMenu;
